module.exports = __webpack_public_path__ + "media/icons/sphere-209b63fe17577e8eccae4fc31c780966.svg";